import * as React from 'react'
import { connect } from 'react-redux'

import { DynamicCx, CommonState } from 'common/types'
import { styling } from 'common/utils'
import { Vertical } from 'common/constants'
import { InfiniteGridScrollTop, setInfinitePageScrollTop } from 'common/ducks/scroll/infiniteGridScrollTop'
import * as s from './footer.scss'
import { isIe9 } from 'common/utils/oldIeVersion'

interface StateProps {
  infiniteGridScrollTop: InfiniteGridScrollTop
}

interface DispatchProps {
  setInfinitePageScrollTop: typeof setInfinitePageScrollTop
}

interface OwnProps {
  vertical?: Vertical
  cx?: DynamicCx
}

type Props = StateProps & DispatchProps & OwnProps

const Footer: React.SFC<Props> = ({ cx, vertical, infiniteGridScrollTop, setInfinitePageScrollTop }) => {
  const handleClickTop = () => {
    window.scrollTo(0, 0)
    if (infiniteGridScrollTop.isInfiniteGridPage) {
      setInfinitePageScrollTop(true)
    }
    const bodyElement = document.getElementById('root')
    if (!bodyElement) return
    bodyElement.tabIndex = -1
    bodyElement.focus()
  }
  const handleExposureTipClick = () => {
    const verticalTap =
      !vertical || [Vertical.DEPARTMENT, Vertical.OUTLET, Vertical.STYLE].includes(vertical)
        ? Vertical.STYLE.toLowerCase()
        : vertical.toLowerCase()
    window.open(
      `https://sell.smartstore.naver.com/#/home/about?tipModal=WINDOW_EXPOSURE&tap=${verticalTap}`,
      `${isIe9() ? '' : 'exposure_tip'}`,
      'width=708,height=812',
    )
  }
  return (
    <>
      <a href="javascript:void(0)" onClick={handleClickTop} className={cx('wrap_top')}>
        맨위로가기
      </a>
      <div className={cx('footer')}>
        <div className={cx('footer_area')}>
          <h2 className={cx('@blind')}>하위영역</h2>
          <div className={cx('info_site')}>
            <a href="http://www.naver.com/rules/service.html" target="_blank" className={cx('@N=a:fot.agreement')}>
              이용약관
            </a>
            <a href="http://www.naver.com/rules/privacy.html" target="_blank" className={cx('@N=a:fot.privacy')}>
              <strong>개인정보처리방침</strong>
            </a>
            <a
              href="https://search.shopping.naver.com/user/legalbasis.nhn"
              target="_blank"
              className={cx('@N=a:fot.disclaimer')}>
              법적고지
            </a>
            <a href="http://join.shopping.naver.com/index.nhn" target="_blank" className={cx('@N=a:fot.join')}>
              입점안내
            </a>
            <a href="javascript:void(0)" onClick={handleExposureTipClick} className={cx('@N=a:fot.shoppingw')}>
              쇼핑윈도 노출안내
            </a>
            <a
              href="https://adcenter.shopping.naver.com/member/login/form.nhn"
              target="_blank"
              className={cx('@N=a:fot.ad')}>
              쇼핑파트너존
            </a>
            <a href="https://sell.storefarm.naver.com/#/home/about" target="_blank" className={cx('@N=a:fot.sfsell')}>
              스마트스토어센터
            </a>
            <a href="https://help.pay.naver.com/index.nhn" target="_blank" className={cx('@N=a:fot.help')}>
              쇼핑&amp;페이 고객센터
            </a>
          </div>
          <p className={cx('marketing')}>
            네이버㈜는 결제정보의 중개서비스 또는 통신판매중개시스템의 제공자로서, 통신판매의 당사자가 아니며 상품의
            주문, 배송 및 환불 등과 관련한 의무와 책임은 각 판매자에게 있습니다.
          </p>
          <address className={cx('address')}>
            <span className={cx('item')}>사업자등록번호 : 220-81-62517</span>
            <span className={cx('item')}>통신판매업신고번호 : 제2006-경기성남-692호</span>
            <span className={cx('item')}>대표이사 : 한성숙</span>
            <a
              href="https://www.ftc.go.kr/www/bizCommList.do?key=232"
              target="_blank"
              className={cx('@N=a:fot.rbinformation', 'item')}>
              사업자등록정보확인
            </a>
            <br />
            <span className={cx('item')}>주소 : 경기도 성남시 분당구 불정로 6 네이버 그린팩토리 13561</span>
            <span className={cx('item')}>대표전화 : 1588-3819</span>
            <span className={cx('item')}>팩스 : 033-816-5304</span>
            <span className={cx('item')}>
              <a href="https://help.pay.naver.com/faq/alias/naver-gu.help" target="_blank">
                <strong>1:1문의 바로가기</strong>
              </a>
            </span>
            <span className={cx('item')}>호스팅 서비스 제공 : NAVER Business Platform</span>
          </address>
          <p className={cx('copyright')}>
            <a href="http://www.naver.com" className={cx('logo')} target="_blank">
              NAVER
            </a>
            Copyright ©
            <strong>
              <a href="http://www.navercorp.com/ko/index.nhn" target="_blank">
                NAVER Corp.
              </a>
            </strong>
            All Rights Reserved.
          </p>
        </div>
      </div>
    </>
  )
}

const styled = styling(s)(Footer)
export default connect<StateProps, DispatchProps, OwnProps>(
  (state: CommonState) => ({
    infiniteGridScrollTop: state.infiniteGridScrollTop,
  }),
  {
    setInfinitePageScrollTop,
  },
)(styled)
